// frontend/src/components/AnimatedOverlay.tsx
import { AnimatePresence, motion } from 'motion/react';

interface Props {
  show: boolean;
  children: React.ReactNode;
}

export default function AnimatedOverlay({ show, children }: Props) {
  return (
    <AnimatePresence initial={false}>
      {show && (
        <motion.div
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%', transition: { duration: 0.26, ease: [0.4, 0, 1, 1] } }}
          transition={{ duration: 0.32, ease: [0.16, 1, 0.3, 1] }}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 50,
            background: 'var(--a-bg)',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            overscrollBehavior: 'contain',
            willChange: 'transform',
          }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
